import {DropdownOption} from '../core/dropdown-option';

export enum OrganizationType {
  ABSTRACTOR = 'ABSTRACTOR',
  LAW_FIRM = 'LAW_FIRM'
}

export const getOrganizationTypeOptions = (): DropdownOption[] => [
  {key: OrganizationType.ABSTRACTOR, value: OrganizationType.ABSTRACTOR, text: 'Abstractor'},
  {key: OrganizationType.LAW_FIRM, value: OrganizationType.LAW_FIRM, text: 'Law Firm'}
];
